import get from 'lodash/get'
import router from '@/router'
import { queryArgs } from '@/utils'

const initialState = () => ({
	settings : {
		tab  : 'general',
		tabs : {
			general     : 'General',
			site        : 'Site Settings',
			billing     : 'Billing',
			subaccounts : 'Sub-Accounts',
			misc        : 'Miscellaneous',
		},
	},
	about : {
		tab  : 'about-us',
		tabs : {
			'about-us'        : 'About Us',
			'getting-started' : 'Getting Started',
			'lite-pro'        : 'Lite vs. Pro',
		},
	},
	monsterleads : {
		tab  : 'overview',
		tabs : {
			overview : 'Overview',
			contacts : 'Contacts',
			segments : 'Segments',
		},
	},
})
export default {
	namespaced : true,
	state      : initialState(),
	getters    : {
		settingsTab  : (state) => state.settings.tab,
		settingsTabs : (state, getters, rootState, rootGetters) => {
			let { tabs } = state.settings
			if (!rootGetters.connected) {
				delete tabs.billing
				delete tabs.subaccounts
			}
			return tabs
		},
		aboutTab : (state, getters, rootState, rootGetters) => {
			const { tab } = state.about
			return rootGetters.showProUpsells ? tab : ('lite-pro' === tab ? 'about-us' : tab)
		},
		aboutTabs : (state, getters, rootState, rootGetters) => {
			if (rootGetters.showProUpsells) {
				return state.about.tabs
			}

			const tabs = { ...state.about.tabs }
			delete tabs['lite-pro']

			return tabs
		},
		monsterleadsTab  : (state) => state.monsterleads.tab,
		monsterleadsTabs : (state) => state.monsterleads.tabs,
	},
	mutations : {
		setTab (state, { page, tab }) {
			const pageOptions = initialState()[page]

			tab = pageOptions.tabs[ tab ]
				? tab
				: pageOptions.tab

			this._vm.$set(state[page], 'tab', tab)
		},
	},
	actions : {
		goTab ({ commit, rootState }, { page, tab, strict = false }) {
			const pageOptions = initialState()[page]

			if (!tab || pageOptions.tab === tab) {
				tab       = pageOptions.tab
			}

			commit('setTab', { page, tab })

			let url = strict ? '' : window.location.search
			url = queryArgs.add('page', 'optin-monster-' + page, url)
			url = queryArgs.add('selectedTab', tab, url)

			// Check for route.
			const route = router.getRouteForQuery(url)
			if (!route) {
				return
			}

			if (
				get(rootState, 'route.name') === get(route, 'name') &&
				get(rootState, 'route.params.selectedTab') === tab
			) {
				// If tab is already set, bail.
				return
			}

			// Go to the tabbed-page.
			router.push({ name: route.name, params: { selectedTab: tab } })
		},

	},
}
